import React from 'react';

const ShiftTitle = ({ record }) => {
	return <span>Shift {record ? `"${record.name}"` : ''}</span>;
};
export default ShiftTitle;
